import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiCoreUserListState } from '@fi-app/user/states/user-list-state';
import { FiCoreAddUserStateV2 } from '@fi-app/user/states/user-add-state';
import { FiCoreEditUserStateV2 } from '@fi-app/user/states/user-edit-state';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiUserRootState: Ng2StateDeclaration = {
    name: FiStateNames.User._name,
    url: '/User',
    abstract: true,
    component: FiAbstractStateComponent,
};

export const FiUserStates: StatesModule = {
    states: [FiUserRootState, FiCoreUserListState, FiCoreAddUserStateV2, FiCoreEditUserStateV2],
};
